export const WORKSPACE_ACCESS_LEVEL = {
  allWorkspaces: 'allWorkspaces',
  onlyCurrentWorkspace: 'onlyCurrentWorkspace',
};
